import { ReferenceArrayInput, SelectArrayInput } from "react-admin";
import { useCurrentDrivingSchoolId } from "../hooks/useCurrentDrivingSchoolId";

export function EntitledInstructorsInput(props: { source: string }) {
  const { source } = props;
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const filter = { drivingSchoolId, isActive: true };
  return (
    <ReferenceArrayInput
      source={source}
      reference="instructors"
      filter={filter}
      sort={{ field: "name", order: "ASC" }}
      perPage={200}
    >
      <SelectArrayInput label="zugeordnete(r) Fahrlehrer" fullWidth />
    </ReferenceArrayInput>
  );
}
